module.exports = __webpack_public_path__ + "img/volume_up.20f7056f.svg";